import CachedIcon from "@mui/icons-material/Cached";
import InputIcon from "@mui/icons-material/Input";
import LaptopIcon from "@mui/icons-material/Laptop";
import SecurityIcon from "@mui/icons-material/Security";
import Visibility from "@mui/icons-material/Visibility";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import {
  Box,
  Button,
  CircularProgress,
  Skeleton,
  TextField,
  Typography,
} from "@mui/material";
import IconButton from "@mui/material/IconButton";
import InputAdornment from "@mui/material/InputAdornment";
import OutlinedInput from "@mui/material/OutlinedInput";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { handleLoginAction } from "../../../redux/actoin";
import { API } from "../../../scripts/api";
import axiosInstance from "../../../scripts/axiosInspector";
import { persianToEnglish } from "../../../scripts/functions";
import HeaderReq from "../../../scripts/functions/headerReq";
const LoginForms = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [data, setData] = useState({});
  const [captcha, setCaptch] = useState({});
  const handleClickShowPassword = () => setShowPassword((show) => !show);
  const [loading, setLoading] = useState(false);
  const [reRender, setRerender] = useState(1);
  const [err, setErr] = useState("");
  const [errC, setErrC] = useState("");
  const dispatch = useDispatch();

  useEffect(() => {
    axiosInstance.get(API.auth.captch, HeaderReq()).then((res) => {
      setCaptch(res.data.data?.chCaptchaBase64);
      setData({
        ...data,
        chEncryptedCaptchaKey:
          res.data.data
            ?.chEncryptedCaptchaKey /* "oX9K8eLW5MY2HsmDtlTt0vcBMqfP3KocLxlaQ7F7L3VmuxsKDOUfP3F2JByZlPtudjraxqXUHrcS4Hjbh/zkJg==" */,
      });
    });
  }, [reRender]);
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleLogin = (e) => {
    e.preventDefault();
    setLoading(true);
    axiosInstance
      .post(
        API.auth.login,
        {
          ...data,
        },

        HeaderReq(null, {
          "Content-Type": "application/json",
          chHostName: process.env.REACT_APP_CHHOSTNAME,
        })
      )
      .then((res) => {
        if (res?.data?.data?.btIsValid) {
          dispatch(
            handleLoginAction({
              userName: res?.data?.data?.chUserTitle,
              token: res?.data?.data?.chToken,
            })
          );
        } else {
          setData({ ...data, chCaptchaKey: "" });
          setRerender((r) => r + 1);
          setErr(res?.data?.message);
          toast.error(res?.data?.message);
        }
        setLoading(false);
      })
      .catch((err) => {
        toast.error("خطایی رخ داده است مجدد تلاش کنید");
        setData({ ...data, chCaptchaKey: "" });
        setRerender((r) => r + 1);
        setLoading(false);
      });
  };
  return (
    <>
      {" "}
      <Box
        component={"form"}
        onSubmit={handleLogin}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          /*    backgroundColor: "#333333", */
          padding: "12px",
          height: "100%",
          gap: 3,
          borderRadius: { md: "4px 0px 0px 4px", xs: "0px 0px 4px 4px" },
        }}
        className="col-span-2 overflow-hidden "
      >
        {/*   */}
        <div className="flex w-full bg-white rounded-md gap-2 items-center pr-2 pl-1">
          <small className="min-w-max">نام کاربری/کد ملی</small>
          <TextField
            id="outlined-basic"
            focused
            variant="outlined"
            fullWidth
            type="text"
            value={data?.chUserName}
            onChange={(e) => setData({ ...data, chUserName: e.target.value })}
            name="chUserName"
          />
        </div>
        <div className="flex w-full bg-white rounded-md gap-2 items-center pr-2 pl-1">
          <small className="min-w-max"> رمز عبور</small>
          <OutlinedInput
            id="outlined-adornment-password"
            value={data?.chPassword}
            onChange={(e) => setData({ ...data, chPassword: e.target.value })}
            name="chPassword"
            fullWidth
            type={showPassword ? "text" : "password"}
            endAdornment={
              <InputAdornment position="right">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="right"
                >
                  {showPassword ? (
                    <VisibilityOff className="pI" />
                  ) : (
                    <Visibility className="pI" />
                  )}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </div>{" "}
        <div className="flex bg-white w-full rounded-md gap-2 items-center pr-2 pl-1">
          <small className="min-w-max"> تصویر امنیتی</small>
          <TextField
            id="outlined-basic"
            variant="outlined"
            fullWidth
            type="tel"
            /*     maxRows={6} */
            value={data?.chCaptchaKey}
            onChange={(e) => {
              if (e.target.value.length <= 6) {
                setData({
                  ...data,
                  chCaptchaKey: persianToEnglish(e.target.value),
                });
                if (e.target.value?.length !== 6) {
                  setErrC("کپچا نامعتبر می باشد ");
                } else {
                  setErrC("");
                }
              }
            }}
            onInput={(e) => {
              e.target.value = e.target.value
                .replace(/[^0-9.]/g, "")
                .replace(/(\..*?)\..*/g, "$1");
            }}
            InputProps={{ inputProps: { min: 0, max: 10 } }}
            error={errC}
            helperText={errC}
            name="chCaptchaKey"
          />{" "}
        </div>
        <Box
          sx={{
            display: "flex",
            height: "45px",
            border: "1px solid #fff",
            borderRadius: "4px",
            width: "100%",
          }}
        >
          {captcha ? (
            <img
              onClick={() => setRerender((r) => r + 1)}
              src={captcha}
              alt=""
              className="w-full"
            />
          ) : (
            <Skeleton
              variant="rounded"
              width={200}
              height={53}
              animation="wave"
            />
          )}

          <IconButton
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "15px 20px",
              cursor: "pointer",
            }}
            onClick={() => setRerender((r) => r + 1)}
          >
            <CachedIcon sx={{ color: "#fff" }} />
          </IconButton>
        </Box>
        <Box
          sx={{
            display: "flex",
            my: "0.25rem",
            width: "100%",
            justifyContent: "center",
          }}
        >
          <Link to="/ForgotPassword">
            <Box
              sx={{
                display: "flex",
                cursor: "pointer",
                ":hover": {
                  background: "#2196f31c",
                },
                alignItems: "center",
                color: "#fff",
                gap: "2px",
              }}
            >
              {" "}
              <SecurityIcon
                sx={{
                  padding: "3px !important",
                  fontSize: { md: "1.2rem", xs: "1.1rem" },
                }}
              />
              <Typography sx={{ fontSize: { md: "0.8rem", xs: "0.8rem" } }}>
                {" "}
                ارسال/فراموشی رمز عبور{" "}
              </Typography>
            </Box>
          </Link>
        </Box>
        <Box
          sx={{
            display: "flex",
            my: "0.25rem",
            width: "100%",
            justifyContent: "space-between",
          }}
        >
          {/*      <Link to="/qrCodeLogin">
          <Box
            sx={{
              display: "flex",
              cursor: "pointer",
              ":hover": {
                background: "#2196f31c",
              },
              alignItems: "center",
              color: "#2196f3",
              gap: "2px",
            }}
          >
            {" "}
            <QrCodeScannerIcon
              sx={{
                padding: "3px !important",
                fontSize: { md: "1.2rem" },
              }}
            />
            <Typography sx={{ fontSize: { md: "0.8rem" } }}>
              ورود با qrCode
            </Typography>
          </Box>
        </Link>

        <Link to="/otp">
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              cursor: "pointer",
              color: "#2196f3",
              gap: "2px",
              borderRadius: "4px",
              ":hover": {
                background: "#2196f31c",
              },
            }}
          >
            <SmsIcon
              sx={{
                padding: "3px !important",
                fontSize: { md: "1.2rem" },
              }}
            />
            <Typography sx={{ fontSize: { md: "0.8rem" } }}>
              ورود با sms
            </Typography>
          </Box>
        </Link> */}
        </Box>
        <Box
          className="mt-[79px]"
          sx={{ px: "15px", mb: "3.25px", width: "100%" }}
        >
          <Button
            variant="contained"
            sx={{
              height: "3.1rem",
              fontSize: "11px",
              width: "100%",
              background: "#2196f3",
            }}
            type="submit"
            disabled={
              !data?.chUserName ||
              !data?.chPassword ||
              loading ||
              data?.chCaptchaKey?.length !== 6
            }
          >
            {loading ? (
              <>
                <CircularProgress />
              </>
            ) : (
              <>
                {" "}
                <LaptopIcon />
                <Typography sx={{ mx: "0.7rem" }}>ورود</Typography>
                <InputIcon />
              </>
            )}
          </Button>
          {err && <div className="text-red-400 mt-2">{err}</div>}
        </Box>
      </Box>
    </>
  );
};

export default LoginForms;
